import React from "react";

/**
 * Map Marker Component for delivery schedule pins
 */
const MapMarker = ({ schedule, getStatusColor, getStatusText, onClick }) => {
  if (!schedule || !getStatusColor || !getStatusText || !onClick) {
    return null;
  }

  return (
    <div
      className="relative cursor-pointer transform hover:scale-110 transition-transform duration-200"
      onClick={() => onClick(schedule)}
      style={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: getStatusColor(schedule.status),
        border: "3px solid white",
        boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
      }}
      title={`${schedule.subscriptionName} - ${getStatusText(schedule.status)}`}
    >
      {/* Status indicator dot */}
      <div
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: "white",
        }}
      />
    </div>
  );
};

export default MapMarker;
